import { useNoteFormContext } from '../context/noteFormContext';

export const useIsTranscribing = () => {
  const { note } = useNoteFormContext();

  const isTranscribing =
    note?.aiScribe?.status === 'TRANSCRIBE_STARTED' ||
    note?.aiScribe?.status === 'TRANSCRIBE_IN_PROGRESS' ||
    note?.aiScribe?.status === 'TRANSCRIBE_COMPLETED' ||
    note?.aiScribe?.status === 'SUMMARIZING';

  return isTranscribing;
};
